export default __webpack_public_path__ + "static/images/46bc2602.png";